import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Option } from "react-select/lib/filters";
import useGetSubjectOptions from "@modules/shared/selectors/hooks/useGetSubjectOptions";
import AdvanceSelector from "../advance-selector";
import { SelectPagination } from "@foris/avocado-suite";

interface AdvancedSubjectSelectorProps {
  campusId?: string;
  curriculumId?: string;
  departmentId?: string;
  levelId?: string;
  modalityId?: string;
  onChange?: (option: Option) => void;
  programId?: string;
  scenario: string;
  shiftId?: string;
  subjectOption?: Option;
  isSimpleSelector?: boolean;
  isDisabled?: boolean;
}

const AdvancedSubjectSelector = ({
  onChange,
  subjectOption,
  isSimpleSelector = false,
  isDisabled = false,
  ...filters
}: AdvancedSubjectSelectorProps) => {
  const [value, setValue] = useState(subjectOption);

  const { loadOptions } = useGetSubjectOptions({
    ...filters,
  });

  const { t } = useTranslation();

  return isSimpleSelector ? (
    <SelectPagination
      label={t("advanced-search.instructor.forms.select-wrapper.subject.label")}
      value={value}
      loadOptions={loadOptions}
      placeholder={t("advanced-search.instructor.forms.select-wrapper.subject.placeholder")}
      onChange={option => {
        setValue(option);
        onChange?.(option);
      }}
      disabled={isDisabled}
    />
  ) : (
    <AdvanceSelector
      isPaginated
      dimension={t("advanced-search.instructor.forms.select-wrapper.subject.label")}
      selectPlaceholder={t("advanced-search.instructor.forms.select-wrapper.subject.placeholder")}
      loadOptions={loadOptions}
      value={value}
      onChange={option => {
        setValue(option);
        onChange?.(option);
      }}
      notShowLabel
    />
  );
};

export default AdvancedSubjectSelector;
